import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { withALErrorBoundary } from "../../helpers/ErrorBoundary/ALErrorBoundary";
import { useLocalizedSentenceDict } from "../../hooks/useSentenceDict";

function CreateAccount({ onSubmit }) {
  const dict = useLocalizedSentenceDict();
  const { register, handleSubmit } = useForm();

  return (
    <>
      <p className="typo-body mb-[25px]">
        {dict.get("Create an account for faster checkout, order updates, and more!")}
      </p>
      <form
        onSubmit={handleSubmit(onSubmit)}
        id="create-account-form"
        className="flex flex-col space-y-[20px]"
      >
        <input
          placeholder={dict.get("Email")}
          type="email"
          className="w-full border border-black rounded-[4px] px-[15px] py-[10px] appearance-none typo-body"
          required
          {...register("email")}
        />

        <div className="flex gap-[10px] desktop:gap-[15px]">
          <input
            placeholder={dict.get("First Name")}
            className="w-1/2 border border-black rounded-[4px] px-[15px] py-[10px] appearance-none typo-body"
            {...register("firstName")}
          />
          <input
            placeholder={dict.get("Last Name")}
            className="w-1/2 border border-black rounded-[4px] px-[15px] py-[10px] appearance-none typo-body"
            {...register("lastName")}
          />
        </div>

        <div className="flex flex-col space-y-[5px]">
          <input
            placeholder={dict.get("Password")}
            type="password"
            className="w-full border border-black rounded-[4px] px-[15px] py-[10px] appearance-none typo-body"
            required
            {...register("password")}
          />
          <p className="typo-micro">{dict.get("Must be 6+ characters and include 1 number.")}</p>
        </div>
      </form>
    </>
  );
}

CreateAccount.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default withALErrorBoundary({
  name: "CreateAccount",
  priority: "P1",
})(CreateAccount);
